import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_POSITIONCHANGE,
  DELETE_POSITIONCHANGE,
  UPDATE_POSITIONCHANGE,
  ADD_NEW_POSITIONCHANGE,
} from "./actionType";

import {
  getPositionChangeSuccess,
  getPositionChangeFail,
  deletePositionChangeSuccess,
  deletePositionChangeFail,
  updatePositionChangeSuccess,
  updatePositionChangeFail,
  addPositionChangeSuccess,
  addPositionChangeFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePositionChangeApi,
  getPositionChangeApi,
  updatePositionChangeApi,
  deletePositionChangeApi,
  addNewPositionChangeApi
} from "../../helpers/backend_helper";

function* getPositionChange({ payload: positionChange }) {
  try {
    const response = yield call(getPositionChangeApi, positionChange);
    yield put(getPositionChangeSuccess(GET_POSITIONCHANGE, response.data));
  } catch (error) {
    yield put(getPositionChangeFail(GET_POSITIONCHANGE, error));
  }
}

function* onUpdatePositionChange({ payload: positionChange }) {
  try {
    if (positionChange.setApprove) {
      const response = yield call(approvePositionChangeApi, positionChange);
      yield put(updatePositionChangeSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePositionChangeApi, positionChange);
      yield put(updatePositionChangeSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePositionChangeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePositionChange({ payload: positionChange }) {
  try {
    const response = yield call(deletePositionChangeApi, positionChange);
    yield put(deletePositionChangeSuccess({ positionChange, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePositionChangeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPositionChange({ payload: positionChange }) {
  try {
    const response = yield call(addNewPositionChangeApi, positionChange);
    yield put(addPositionChangeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPositionChangeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPositionChange() {
  yield takeEvery(GET_POSITIONCHANGE, getPositionChange);
}

export function* watchUpdatePositionChange() {
  yield takeEvery(UPDATE_POSITIONCHANGE, onUpdatePositionChange);
}

export function* watchDeletePositionChange() {
  yield takeEvery(DELETE_POSITIONCHANGE, onDeletePositionChange);
}

export function* watchAddNewPositionChange() {
  yield takeEvery(ADD_NEW_POSITIONCHANGE, onAddNewPositionChange);
}

function* positionChangeSaga() {
  yield all([
    fork(watchGetPositionChange),
    fork(watchDeletePositionChange),
    fork(watchUpdatePositionChange),
    fork(watchAddNewPositionChange)
  ]);
}

export default positionChangeSaga;
